import React, { useState, useEffect } from 'react';
import Sidebar from '../components/Sidebar';
import MobileMenuToggle from '../components/MobileMenuToggle';
import NotificationIcon from '../components/NotificationIcon';
import NotificationsModal from '../components/NotificationsModal';
// Provider moved to App level to avoid double wrapping and import issues
import './DashboardLayout.css';

const DashboardLayout = ({ children, modalOpen }) => {
  const [sidebarOpen, setSidebarOpen] = useState(() => {
    // Default to true for desktop, but check local storage
    const saved = localStorage.getItem('sidebarOpen');
    return saved !== null ? JSON.parse(saved) : true;
  });
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => {
      const mobile = window.innerWidth <= 768;
      setIsMobile(mobile);
      if (mobile) {
        setSidebarOpen(false);
      } else {
        // Restore from localStorage when switching back to desktop
        const saved = localStorage.getItem('sidebarOpen');
        setSidebarOpen(saved !== null ? JSON.parse(saved) : true);
      }
    };

    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  // Persist sidebar state whenever it changes (on desktop)
  useEffect(() => {
    if (!isMobile) {
      localStorage.setItem('sidebarOpen', JSON.stringify(sidebarOpen));
    }
  }, [sidebarOpen, isMobile]);

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  return (
    <div className="dashboard-layout">
      <MobileMenuToggle onClick={toggleSidebar} isOpen={sidebarOpen} />
      <Sidebar
        sidebarOpen={sidebarOpen}
        setSidebarOpen={setSidebarOpen}
        isMobile={isMobile}
      />
      <main className={`main-content${sidebarOpen ? ' sidebar-open' : ' sidebar-collapsed'}`}>
        {children}
      </main>
      {isMobile && sidebarOpen && (
        <div className="mobile-overlay" onClick={() => setSidebarOpen(false)} />
      )}
      {!modalOpen && <NotificationIcon />}
      <NotificationsModal />
    </div>
  );
};

export default DashboardLayout; 